import { purchaseOrdersListingStore } from '@/app/features/purchase-orders/features/purchase-orders-listing/purchase-orders-listing.store';
import { purchaseOrderDetailsStore } from './features/purchase-order-details/purchase-order-details.store';
export const purchaseOrdersStore = {
  modules: {
    purchaseOrdersListingStore,
    purchaseOrderDetailsStore
  }
};
